import React, { useRef } from "react";
import {
  Chart,
  Series,
  Tooltip,
  Legend,
  ArgumentAxis,
  ValueAxis,
  Point,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const EclActuarialGapDistribution = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeTooltip = (info) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${info.argumentText}</div>
          <div>Fifo lines : ${info.value}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Actuarial Rate gap distribution"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="actuarialGapDistributionChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            name="Fifo lines number by Actuarial rate gap (basis point)"
            valueField="count"
            argumentField="interval"
            type="line"
          >
            <Point visible={true} size={7} symbol="circle" />
          </Series>

          <ArgumentAxis
            label={{
              displayMode: "rotate",
              rotationAngle: 45,
            }}
          />
          <ValueAxis />

          <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
          <Legend
            visible={true}
            verticalAlignment="bottom"
            horizontalAlignment="center"
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default EclActuarialGapDistribution;
